import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/converging.pdf'; 
import { Helmet } from 'react-helmet';

function Converging() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
       Source:<br /><br />
		<var>S&#228;mtliche schriften und briefe series VII volume 3</var><br />
        Deutsche Akademie der Wissenschaften (ed)<br />
        p 798<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}    
		Date: June 1676 (?)<br /><br />
        Translated from the Latin<br /><br /> {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (71k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>On Converging Series</title>
            <meta name="description" content="An English translation of ON CONVERGING SERIES by Gottfried Wilhelm Leibniz, from June 1676 (?)" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: ON CONVERGING SERIES</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                [<b>A VII 3, 798</b>]<br /><br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;If one supposes the value of a sector&#8212;that is, of a converging series of polygons&#8212;given in numbers, no mortal can know whether or not it is composed in the same way from converging terms. Therefore, it does not even serve as a criterion.
                <br /><br /><br />
                &#169; Lloyd Strickland 2022
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Converging;
